import React from 'react'
import {Link} from 'react-router-dom'
const Sidebar = () => {
    /* Set the width of the side navigation to 0 */
    function closeNav() {
        document.getElementById("mySidenav").style.width = "0";
        document.body.style.backgroundColor = "white";
        document.getElementById("hamburger").style.display = "block";
    }
    return (
        <>
            <div id="mySidenav" className="sidenav">
                <Link to="javascript:void(0)" className="closebtn" onClick={()=>closeNav()}>&times;</Link>
                <Link className="link" to="/">
                <div className="brand-name">
                    <img className="img-logo" src="/images/logo.png" />
                    <span className="navbrand">Foam UI</span>
                </div>
                </Link>
                <div>
                <h4>
                    <Link className="link" to="/main/intro">Introduction</Link>
                </h4>
                <h4>Components</h4>
                <ul className="list-non-bullet list-sidebar">
                    <li className="sidebar-item">
                        <Link className="sidebar-link link-active" to="/main/alert">Alert</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link className="sidebar-link" to="/main/avatar">Avatar</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link className="sidebar-link" to="/main/badge">Badge</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link className="sidebar-link" to="/main/button">Button</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link className="sidebar-link" to="/main/card">Card</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link className="sidebar-link" to="/main/grid">Grid</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link className="sidebar-link" to="/main/image">Image</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link className="sidebar-link" to="/main/input">Input</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link className="sidebar-link" to="/main/modal">Modal</Link>
                    </li>
                    <li className="sidebar-item">
                        <Link className="sidebar-link" to="/main/navigation">Navigation</Link>
                    </li>
                </ul>
                </div>
            </div>

            <div className="sidebar">
                <h4>
                <Link className="link" to="/main/intro">Introduction</Link>
                </h4>
                <h4>Components</h4>
                <ul className="list-non-bullet list-sidebar">
                <li className="sidebar-item">
                    <Link className="sidebar-link" to="/main/alert">Alert</Link>
                </li>
                <li className="sidebar-item">
                    <Link className="sidebar-link" to="/main/avatar">Avatar</Link>
                </li>
                <li className="sidebar-item">
                    <Link className="sidebar-link" to="/main/badge">Badge</Link>
                </li>
                <li className="sidebar-item">
                    <Link className="sidebar-link" to="/main/button">Button</Link>
                </li>
                <li className="sidebar-item">
                    <Link className="sidebar-link" to="/main/card">Card</Link>
                </li>
                <li className="sidebar-item">
                    <Link className="sidebar-link" to="/main/grid">Grid</Link>
                </li>
                <li className="sidebar-item">
                    <Link className="sidebar-link" to="/main/image">Image</Link>
                </li>
                <li className="sidebar-item">
                    <Link className="sidebar-link" to="/main/input">Input</Link>
                </li>
                <li className="sidebar-item">
                    <Link className="sidebar-link" to="/main/modal">Modal</Link>
                </li>
                <li className="sidebar-item">
                    <Link className="sidebar-link" to="/main/navigation">Navigation</Link>
                </li>
                </ul>
            </div>
        </>
    )
}
export default Sidebar
